export enum EventType {
  NOTIFICATION = 'NOTIFICATION',
  CREATE_UPDATE = 'CREATE_UPDATE',
  GENERATE_REPORT = 'GENERATE_REPORT',
}

export const eventTypeMetadata: Record<EventType, { private: boolean }> = {
  [EventType.NOTIFICATION]: { private: false },
  [EventType.CREATE_UPDATE]: { private: true },
  [EventType.GENERATE_REPORT]: { private: true },
}

export const eventBus = ref(new EventTarget())

const eventSource = shallowRef<EventSource | null>(null)

export const useSSE = () => {
  const events = ref<{ type: EventType; data: any }[]>([])

  const startEventSource = () => {
    if (
      eventSource.value &&
      eventSource.value.readyState !== EventSource.CLOSED
    )
      return

    eventSource.value = new EventSource(
      `${import.meta.env.VITE_API_BASE_URL}/connect-events`,
      {
        withCredentials: true,
      },
    )

    eventSource.value.onopen = () => {
      eventSource.value!.addEventListener('ping', () => {})
    }

    eventSource.value.addEventListener(EventType.CREATE_UPDATE, (event) => {
      const eventData = { type: EventType.CREATE_UPDATE, data: event.data }

      events.value.push(eventData)
      eventBus.value.dispatchEvent(
        new CustomEvent(EventType.CREATE_UPDATE, {
          detail: JSON.parse(event.data),
        }),
      )
    })
  }

  startEventSource()

  return {
    events,
  }
}
